module.exports = __webpack_public_path__ + "static/media/7.7e218be6.jpg";